import { map } from 'lodash';

export type CreatableOptionType = { value: string; label: string };

type SelectOption = {
    value: string;
    text: string;
};
export const transformLabelsToSelectOptions = (labels: undefined | null | string[]): SelectOption[] =>
    map(labels, (item) => ({ value: item, text: item }));
